import { render, staticRenderFns } from "./InspectionDetail.vue?vue&type=template&id=216263d8&scoped=true&"
import script from "./InspectionDetail.vue?vue&type=script&lang=ts&"
export * from "./InspectionDetail.vue?vue&type=script&lang=ts&"
import style0 from "./InspectionDetail.vue?vue&type=style&index=0&id=216263d8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "216263d8",
  null
  
)

export default component.exports